import React, { useEffect } from "react";

import { Outlet, useNavigate } from "react-router-dom";
import { Box, Grid } from "@mui/material";
import LayoutWrapper from "../../common/LayoutWrapper";
import AppointmentForm from "../../components/appointment/AppointmentForm";
import { Toaster } from "react-hot-toast";
const AppointmentPage = () => {
  const navigate = useNavigate();
  useEffect(() => {
    if (!localStorage.getItem("token") && !localStorage.getItem("auth")) {
      navigate("/");
    }
  }, [navigate]);
  return (
    <>
      <Toaster />
      <Box className="family-tree-main-container">
        <Grid container spacing={5} className="balance-of-assets">
          <Grid item xl={2} lg={2} sm={12} xs={12}></Grid>
          <Grid item xl={8} lg={8} sm={12} xs={12} > 
            <LayoutWrapper
              borderShadow={true}
              minHeight="calc(100vh - 100px) !important"
            >
              <AppointmentForm />
            </LayoutWrapper>
          </Grid>
          <Grid item xl={2} lg={2} sm={12} xs={12}></Grid>

        </Grid>
      </Box>
    </>
  );
};

export default AppointmentPage;
